import { z } from "zod";
import { createServiceSchema } from "./service.schemas"
import { createInvitationSchema } from "./invitation.schemas";

// STEP 1: Identidad y Contacto (Se mapea a Clinic y ClinicSettings)
export const step1OnboardingSchema = z.object({
  name: z.string().min(2, "El nombre es obligatorio"),
  slug: z.string().min(2, "El slug es obligatorio"),
  isMain: z.boolean().default(false),
  address: z.string().min(5, "La dirección es obligatoria"),
  phone: z.string().optional(),
  email: z.string().email("Email de contacto inválido"),
  city: z.string().optional(),
  street: z.string().optional(),
  housenumber: z.string().optional(),
  country: z.string().optional(),
  zipCode: z.string().optional(),
  latitude: z.number().optional().default(0),
  longitude: z.number().optional().default(0),
});

// Step 2
const timeRangeSchema = z.object({
  start: z.string().regex(/^([01]\d|2[0-3]):([0-5]\d)$/, "Formato HH:mm"),
  end: z.string().regex(/^([01]\d|2[0-3]):([0-5]\d)$/, "Formato HH:mm"),
});

export const step2OnboardingSchema = z.object({
  timezone: z.string().optional(),
  defaultDuration: z.coerce.number().min(15).max(240), // z.coerce para evitar el error de string/number
  bufferTime: z.coerce.number().min(0).max(60).default(10),

  weeklySchedule: z.object({
    monday: z.array(timeRangeSchema).default([]),
    tuesday: z.array(timeRangeSchema).default([]),
    wednesday: z.array(timeRangeSchema).default([]),
    thursday: z.array(timeRangeSchema).default([]),
    friday: z.array(timeRangeSchema).default([]),
    saturday: z.array(timeRangeSchema).default([]),
    sunday: z.array(timeRangeSchema).default([]),
  }),

  holidays: z.array(z.string()).default([]),
});

// Step 3 -> realmente es el de crear un servicio
export const step3OnboardingSchema = createServiceSchema;

// Step 4 -> realmente es el de invitar a profesional
export const step4OnboardingSchema = createInvitationSchema;

export const updateOnboardingStepSchema = z.object({
  currentStep: z.number().min(1).max(4),
  data: z.any().optional(),
  isCompleted: z.boolean().optional(),
}).strict();
